<template>
  <section class="orders">
    <header-com/>
    <img src='/images/order/share_banner.png' class='banner'>
    <div class='goodsContent'>
        <div>
            请选择任意一款心爱的小礼品 <img src='/images/order/Shape.png' class='tips' @click='popupShow= true'>
        </div>
        <div class='box' v-for="(item,index) in list" :key='index'>
            <img :src='item.pic | formatImgUrl(400,400,true)' >
            <div class='box_right'>
                <h3>{{item.name}}</h3>
                <P style='margin-top:10px;'  v-html="item.description"></P>
                
                <div class='price'>¥{{item.price}}</div>
                <button class="primary sendback" @click='reciver(item.id)' :disabled='disable' >{{ item.id == getGiftId?'已领取':''}}</button>
            </div>
            <div style='clear:both'></div>
        </div>
    </div>
    <van-popup class="popup" v-model="popupShow">
        <div class="content f14">
            <h3 class=" bold">规则说明：</h3>
            <p>1.礼品二选一，一次消费只能领取一个礼品；</p>
            <p>2.分享成功并保留8小时以上，礼品会随包裹一同出库寄回。</p>
            <p>3.分享成功后需要点击【一键领取】领取优惠券礼包。</p>
            
        </div>
    </van-popup>
    

    <van-popup class="popup t_center" v-model="isShowSharePopup" height="auto">
        <div @click="isShowSharePopup=false">
            <img src="/images/my/share_arrow.png" alt="" class='shareTip'/>
        </div>
        
    </van-popup>
    <van-popup position="center" v-model="couponsShow">
        <div class="couponsContent">
            <div class='couponsTitle'>优惠券大礼包</div>
            <div class='couponsList' v-for='(item,index) in couponsList' :key='index'>
                <div class='text_content'>
                    <div class='title'><span>{{item.discountAmount}}</span>元</div>
                    <div class='dero'>{{item.description}}</div>
                </div>
            </div>
            <div class='applyBtn_content'>
                <button class="btn-small-highlight-round applyBtn" @click='applyCoupons'>一键领取</button>
            </div>
            
        </div>

    </van-popup>
  </section>
</template>

<script>
  import orderApi from '@/axios/order';
  import wxConfig from '@/assets/js/wx.config'
  import wxShare from "@/assets/js/wx.share"
  import myApi from '@/axios/my';
  import { Toast } from 'vant';
  import { Icon } from 'vant';
  import { setTimeout } from 'timers';
  import $ from 'jquery';
  import zhugeObj from '@/assets/js/track';
  export default {
    name: 'share',
    data () {
      return {
        couponsShow : false,
        getGiftId : '',
        activityId : null,
        giftId : null,
        disable : false,
        isShowSharePopup : false,
        popupShow : false,
        list:[

        ],
        cDetail : {},
        shareBody : {},
        type : 0,
        couponsList : [
          
        ]
      }
    },
    
    created () {
        let _this = this;  
        this.getGiftList();
        this.setShare();
        this.getShareCoupons();
    },
    computed:{
        servicePhone(){
            return this.$store.state.servicePhone;
        },
        customerId(){
            return this.$store.state.customerId;
        }
    },  
    async mounted () {
        // this.shareBody = JSON.parse(this.$route.query.shareBody);
    },
    methods: {
        getShareCoupons(){
            orderApi.getShareCoupons().then((r)=>{
                this.couponsList = r;
            })
        },
        applyCoupons(){
            //领取优惠券
            
            orderApi.setShareCoupons(this.cDetail.batchCode).then((r)=>{
                this.$router.push({name:'couponList'});
            })
        },
        setShare(){
            let _this = this
            // console.log(2)
            //分享type 类型是1
            let shareBody = {};
            orderApi.shareConfig({configType:1}).then((res)=>{
                res.forEach((item,index)=>{
                    if(item.servicePhoneList){
                        if(item.servicePhoneList.indexOf(this.servicePhone) > -1){
                            shareBody = item;
                        }
                    }

                });

                if(JSON.stringify(shareBody) == '{}'){
                    res.forEach((item,index)=>{
                        if(!item.servicePhoneList || item.servicePhoneList.length == 0){
                            shareBody = item
                        }
                    });
                }
                shareBody.link = location.origin+"/link/"+shareBody.link;


                
                wxConfig({
                    path : window.location.href
                },()=>{
                    
                    wxShare(shareBody,function(){
                        // alert(new Date().getTime());
                        // if(_this.cDetail.canDrawCoupon){
                        //     _this.couponsShow = true;
                        // }
                         
                        let params = {
                            activityId: _this.activityId,
                            customerId : _this.customerId,
                        }
                        if(_this.giftId){
                            params.giftId = _this.giftId
                        }

                        zhugeObj.track({
                            title : '打包寄回-分享有礼',
                            content : {
                                '赠品id' : _this.giftId
                            }
                        })
                        
                        $.ajax({
                            url : 'http://mi.baozheng.cc/wxtest',
                            data : params,
                            type : 'GET',
                        })

                        
                        $.ajax({
                            url : '/open/api/nice-api-customer/v1/other/shareGift/draw',
                            data : JSON.stringify(params),
                            type : 'POST',
                            dataType:'json',
                            contentType:'application/json',
                            headers: {
                                "Authorization": 'Bearer ' +  _this.$store.state.token,
                            },
                            success: function(data,textStatus) {
                         
                                zhugeObj.track({
                                    title : '打包寄回-分享有礼成功',
                                    content : {
                                        '赠品id' : _this.giftId
                                    }
                                })
                                let params_share = {
                                    token : _this.$store.state.token,
                                    serviceState : res,
                                    path : '分享添加赠品成功'
                                }
                                
                                orderApi.shareLog(params_share).then((r)=>{
                                    
                                })
                                 _this.getGiftList();
                                 _this.isShowSharePopup = false;
                                _this.$router.back();
                            },
                        })

                        setTimeout(()=>{
                            myApi.postShareGift(params).then((res)=>{
                                console.log(res)
                               
                                zhugeObj.track({
                                    title : '打包寄回-分享有礼成功',
                                    content : {
                                        '赠品id' : _this.giftId
                                    }
                                })
                                let params_share = {
                                    token : _this.$store.state.token,
                                    serviceState : res,
                                    path : '分享添加赠品成功'
                                }
                                
                                orderApi.shareLog(params_share).then((r)=>{
                                    
                                })
                                _this.getGiftList();
                                _this.isShowSharePopup = false;
                                _this.$router.back();
                            }).catch((res)=>{
                                zhugeObj.track({
                                    title : '打包寄回-分享有礼异常',
                                    content : {
                                        '赠品id' : _this.giftId
                                    }
                                })
                                let params_share = {
                                    token : _this.$store.state.token,
                                    serviceState : res.message,
                                    path : '分享添加赠品失败'
                                }
                                orderApi.shareLog(params_share).then((r)=>{

                                })
                                
                                Toast(res.message)
                            })
                        },5000);

                       
                        
                        zhugeObj.track({
                            title : '打包寄回-分享有礼结束',
                            content : {
                                '赠品id' : _this.giftId
                            }
                        })

                        
                    })
            });
                    
            })
        },

        shareGift(id){
            let params = {
                activityId : id
            }
            myApi.shareGift(params).then((res)=>{
                this.getGiftId = res.drewGiftId;
                this.disable = !res.enableDraw;
                this.cDetail = res;
                if(this.cDetail.canDrawCoupon && this.disable){
                    // alert(new Date().getTime());
                    this.couponsShow = true;
                }
            })
        },
        reciver(id){
            this.isShowSharePopup = true;
            this.giftId = id;
        },

        getGiftList(){
            // alert(new Date().getTime());
            myApi.getshareGift({}).then((res)=>{
                res.giftBoList.forEach(element => {
                    if(element.description){
                        element.description = element.description.split('\n').join('<br/>');
                    }
                });
                this.list = res.giftBoList;
                this.activityId = res.id;
                this.shareGift(res.id);
            })
        }
    }
  }
</script>

<style scoped lang="scss">
    .couponsTitle{
        text-align: center;
        color:#4A4A4A;
        font-size: 48px;
        margin-bottom: 40px;
    }
    .applyBtn_content{
        display: flex;
        justify-content: center;
    }
    .applyBtn{
        width: 240px!important;
        height: 72px!important;
        border-radius: 36px!important;
        margin-top: 20px;
    }
    .couponsContent{
        background: rgba(243,251,251,1);
        padding:40px;
        .couponsList{
            width: 610px;
            height: 180px;
            background: url('/images/order/couponsBg.png') no-repeat;
            background-size:100%; 
            box-shadow:0px 1px 10px 0px rgba(0,0,0,0.1);
            display: flex;
            margin-bottom: 20px;

            .text_content{
                margin-left:250px;
                margin-top: 25px;
                font-size:26px; 
                .title{
                    line-height: 70px;
                    span{
                        font-size:55px; 
                    }
                }
                .dero{
                    line-height: 40px;
                    color:#666666;
                }
            }
        }
    }
    .t_center{
        width: 100%;
        height: 100%;
        background: transparent;
        div{
            width: 100%;
            height: 100%;
        }
    }
    .shareTip{
        padding-top: 40px;
        width: 95%;
    }
    .popup{
        border-radius: 10px;
    }
    .content{
        width: 500px;
        padding: 40px;
        padding-top: 20px;
        padding-bottom: 50px;
        border-radius:5px; 
        h3{
            font-size: 28px;
            line-height: 100px;
            color:#333333;
        }
        p{
            font-size: 28px;
            color:#333333;
            line-height: 50px;
        }
    }
    .price{
        color:#68DEDF;
        margin-left:30px; 
        font-size: 40px;
        line-height: 80px;
    }
    .sendback{
        height: 60px!important;
        line-height:60px!important;
        margin-left: 30px;
        min-width: 200px!important;
    }
    .box{
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 10px 0px rgba(0,0,0,0.15);
        border-radius:8px;
        margin-top: 40px;
        margin-bottom: 40px;
        img{
            width: 56%;
            float: left;
        }
        .box_right{
            width: 39%;
            float: left;
            font-size:30px; 
            h3{
                margin-left:30px; 
                line-height: 40px;
                margin-top: 20px;
                font-weight: 600;
                font-size:30px; 
            }
            p{
                margin-left: 30px;
                font-size: 20px;
                line-height: 35px;
            }
        }
    }
    .tips{
        width: 30px;
        position: relative;
        top:6px;
    }
    .banner{
        width: 100%;
    }
    .goodsContent{
        width: 100%;
        position: relative;
        top:-130px;
        &>div{
            font-size: 28px;
            color:#333333;
            margin-left: 50px;
            margin-right:50px;
        } 
    }
</style>
